import React from "react";
import Select from "react-select";
import { useTranslation } from "react-i18next";
import styles from "./styles.module.scss";
import {
  getStartTimeIncrementOptions,
  StartTimeIncrementOption,
} from "app/utils/startTimeIncrementOptions";

interface Props {
  value: number | null;
  disabled?: boolean;
  onChange: (value: number) => void;
}

// CN-2533: the facility scheduling interval, moved off the CoachNow admin panel.
// It is the recommended default shown in each coach's start-time increment picker;
// coaches may override it. Mirrors Facility::SCHEDULING_INTERVALS.
const StartTimeIncrement = ({ value, disabled, onChange }: Props) => {
  const { t } = useTranslation();

  const options: StartTimeIncrementOption[] = getStartTimeIncrementOptions(t);

  return (
    <div className={styles.container}>
      <div className={styles.first_row}>
        <div className={styles.title}>{t("Start Time Increments")}</div>
      </div>
      <p className={styles.description}>
        {t(
          "Set the recommended interval for athlete session start times. It is the default in each coach's settings, and coaches can adjust it for themselves.",
        )}
      </p>
      <div className={styles.select}>
        <Select
          inputId="facility-start-time-increment"
          aria-label={t("Start Time Increments")}
          isDisabled={disabled}
          options={options}
          value={options.find((option) => option.value === value) ?? null}
          onChange={(option: any) => onChange(option.value)}
          // This is the last section on the page, so open upward when there is no
          // room below to keep all options visible.
          menuPlacement="auto"
          menuPortalTarget={
            typeof document !== "undefined" ? document.body : undefined
          }
          styles={{
            menuPortal: (base: any) => ({ ...base, zIndex: 9999 }),
          }}
        />
      </div>
    </div>
  );
};

export default StartTimeIncrement;
